__turbopack_context__.v({
  "arrow": "advanced-sidebar-footer-module-sass-module__LEuYba__arrow",
  "list": "advanced-sidebar-footer-module-sass-module__LEuYba__list",
  "mainMenuItem": "advanced-sidebar-footer-module-sass-module__LEuYba__mainMenuItem",
  "opened": "advanced-sidebar-footer-module-sass-module__LEuYba__opened",
  "selected": "advanced-sidebar-footer-module-sass-module__LEuYba__selected",
  "separator": "advanced-sidebar-footer-module-sass-module__LEuYba__separator",
});
